/// <reference path="student.module.ts" />
module Meevo.Plugins.Controls {

    class TerminateStudentController {

        static $inject = [
            'context',
            '$filter',
            '$mdDialog',
            '$translate',
            'employee'
        ];

        public selectedHomeLocation: Model.LocationListItem;
        public terminatedDate: Date;
        public hireDate: Date;
        public doChangeHomeLocation: boolean;
        public doDeleteFutureWorkTime: boolean;
        public doDeleteFutureBlockTime: boolean;
        public doInactivateUserAtAllLocations: boolean = false;
        public message: string;

        constructor(
            public context: Plugins.Student.StudentContext,
            protected $filter: angular.IFilterService,
            protected  $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            public employee: Model.Employee
        ) {
            this.terminatedDate = moment(employee.terminatedDate).toDate();
            this.hireDate = moment(employee.hireDate).toDate();
            this.message = '';
        }

        public apply = () => {
            let vm = this;
            this.message = '';
            if (Model.Guard.isNothing(this.terminatedDate)) {
                this.message = this.$translate.instant("LABEL_STUDENT_GRADUATION_REQUIRED_DATE");
                return;
            } else if (moment(this.terminatedDate).isAfter(new Date())) {
                this.message = this.$translate.instant("MESSAGE_STUDENT_GRADUATION_DATE_MUST_BE_IN_PAST");
                return;
            } else if (moment(this.terminatedDate).isBefore(this.hireDate)) {
                this.message = this.$translate.instant("MESSAGE_STUDENT_GRADUATION_DATE_VALIDATION");
                return;
            }

            vm.context.terminate(this.terminatedDate,
                vm.doDeleteFutureWorkTime,
                vm.doDeleteFutureBlockTime,
                vm.selectedHomeLocation,
                vm.doInactivateUserAtAllLocations);

            this.$mdDialog.hide();
        };

        public cancel = () => {
            this.$mdDialog.hide();
        };

    }

    angular.module("meevo.plugins.student")
        .controller("meevo.plugins.student.TerminateStudentController", TerminateStudentController);
}